import { render, staticRenderFns } from "./ContactsTitleBlock.vue?vue&type=template&id=26347b25"
import script from "./ContactsTitleBlock.vue?vue&type=script&lang=js"
export * from "./ContactsTitleBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports